import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import images from '../../../assets/images';
import { useErrorBoundary } from 'react-error-boundary';
const ErrorComponent = ({ error, btnText, url, goToInitBtnSecondAction = false }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { resetBoundary } = useErrorBoundary();
    const getDescription = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return { __html: (t(`texts.errorPageTexts.${error}.description`)) };
    };
    const getSubdescription = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return { __html: (t(`texts.errorPageTexts.${error}.subdescription`)) };
    };
    const goTo = () => {
        resetBoundary();
        navigate(url || '/');
    };
    return (_jsxs("div", Object.assign({ className: 'error-component' }, { children: [_jsx(Helmet, { children: _jsxs("title", { children: ["Signo | ", t('texts.errorPageTexts.pageTitle')] }) }), _jsx("img", { className: 'img-error grid-mb-2', src: images.imgError, alt: '' }), _jsx("h1", Object.assign({ className: "grid-mb-1", "data-testid": "error-page-title" }, { children: t('texts.errorPageTexts.pageTitle') })), _jsx("div", { className: "grid-mb-1", "data-testid": "error-page-description", dangerouslySetInnerHTML: getDescription() }), getSubdescription() !== undefined && (_jsxs(_Fragment, { children: [_jsx("div", { className: "", "data-testid": "error-page-subdescription", dangerouslySetInnerHTML: getSubdescription() }), _jsxs("div", Object.assign({ className: "grid-mt-2 actions-error-comp" }, { children: [goToInitBtnSecondAction &&
                                _jsx(Button, Object.assign({ type: "button", onClick: () => navigate('/') }, { children: t('common.btn.goToInit') })), _jsx(Button, Object.assign({ className: 'btn_error_inicio', type: "button", variant: "contained", onClick: goTo }, { children: !btnText ? t('common.btn.goToInit') : t(btnText) }))] }))] }))] })));
};
export default ErrorComponent;
